'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'bath';
var width = 512;
var height = 512;
var aliases = [128705,"bathtub"];
var unicode = 'f2cd';
var svgPathData = 'M40 0l-8 0 0 272-32 0 0 16 32 0 0 80c0 38.1 19 71.7 48 91.9l0 52.1 16 0 0-42.8c14.5 6.9 30.8 10.8 48 10.8l224 0c17.2 0 33.5-3.9 48-10.8l0 42.8 16 0 0-52.1c29-20.2 48-53.9 48-91.9l0-80 32 0 0-16-464 0 0-256 52.7 0 43.1 43.1c-9.9 12.3-15.7 27.9-15.7 44.9 0 23.1 10.9 43.7 27.8 56.9-.3 .3-2.7 2.7-7.1 7.1l11.3 11.3 5.7-5.7 104-104 5.7-5.7-11.3-11.3-5.7 5.7-1.5 1.5c-13.2-16.9-33.7-27.8-56.9-27.8-17 0-32.6 5.9-44.9 15.7L109.7 2.3 107.3 0 40 0zM245.4 71.3l-78.2 78.2c-14.1-10.2-23.3-26.7-23.3-45.4 0-30.9 25.1-56 56-56 18.7 0 35.3 9.2 45.4 23.3zM48 288l416 0 0 80c0 53-43 96-96 96l-224 0c-53 0-96-43-96-96l0-80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBath = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;